import { TextField } from '@mui/material'
import React from 'react'
import { useRecoilValue } from 'recoil'
import useSavePatient from 'src/Patient/hooks/useSavePatient'
import { errorsFormRegisterState, valuesFormRegisterState } from 'src/Patient/state/atoms'
import InputLabelCustom from 'src/shared/components/forms/InputLabelCustom'
import { userState } from 'src/store/user/userState'

const RutField = () => {
    const { handleChange } = useSavePatient();
    const { uswRut } = useRecoilValue(valuesFormRegisterState);
    const { uswRut: errorUswRut } = useRecoilValue(errorsFormRegisterState);

    const user = useRecoilValue(userState);

    return (
        <>
            <InputLabelCustom htmlFor="input-rut" text={`RUT ${!user.payload ? '(*)' : ''}`} />
            <TextField
                disabled={user.payload ? true : false}
                id="input-rut"
                size="small"
                error={errorUswRut && errorUswRut.length > 0 ? true : false}
                helperText={errorUswRut && errorUswRut.length > 0 ? `${errorUswRut.join("\n")}` : ''}
                style={{ width: '100%' }}
                name="uswRut"
                type="text"
                value={uswRut || ""}
                inputProps={{
                    maxLength: 12
                }}
                InputLabelProps={{
                    shrink: true
                }}
                variant="outlined"
                onChange={handleChange}
                autoComplete="off"
                placeholder='Ej: 16.000.000-0'
            />
        </>
    )
}

export default RutField
